<app-header [isAlerts]="true" [hideBackButton]="true"></app-header>
<ng-container *ngIf="preferencesPageViewModel$ | async as viewModel">
  <ion-content id="main-content" class="gray-content-bg">
    <app-manage-alerts-header></app-manage-alerts-header>
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <ion-card
            class="alerts-container"
            role="region"
            aria-labelledby="alerts-title"
          >
            <ion-card-header>
              <div class="alerts-container-header">
                <ion-card-title class="alerts-container-title"
                  >{{ 'i18n.notifications.preferences.activeAlerts' | translate
                  }}</ion-card-title
                >
                <ion-button
                  data-cy="alert-settings-button"
                  class="alert-settings-button"
                  (click)="onSettingsButtonClick()"
                  fill="clear"
                  size="small"
                  aria-label="Open Alert Settings"
                  aria-haspopup="true"
                  aria-controls="settings-flyout"
                >
                  <ion-icon
                    class="settings-icon"
                    name="settings-outline"
                  ></ion-icon>
                  <ion-label class="settings-label"
                    >{{ 'i18n.notifications.preferences.alertSettings' |
                    translate }}</ion-label
                  >
                </ion-button>
              </div>
            </ion-card-header>
            <ion-card-content class="alerts-container-content">
              <ion-grid>
                <ion-row>
                  <ion-col
                    size-sm="6"
                    size-md="4"
                    size-lg="4"
                    *ngFor="
                      let panelViewModel of viewModel.alertPanelViewModels;
                      let i = index;
                      trackBy: trackByAlertPanel
                    "
                    class="alert-panel-column"
                  >
                    <div class="alert-panel">
                      <app-alert-panel
                        [attr.data-cy]="'alert-panel-' + i"
                        [viewModel]="panelViewModel"
                        (panelClick)="onAlertPanelClick($event)"
                      ></app-alert-panel>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-grid>
              <div
                *ngIf="viewModel.alertPanelViewModels.length === 0"
                class="no-alerts"
              >
                <ion-icon name="notifications-off-outline"></ion-icon>
                <p>No alert categories are available</p>
              </div>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ng-template #loading>
      <div class="loading-alerts">
        <ion-spinner name="circular"></ion-spinner>
        <p>Loading your alert preferences...</p>
      </div>
    </ng-template>
    <app-footer></app-footer>
  </ion-content>
  <ion-menu
    side="start"
    menuId="flyout"
    contentId="main-content"
    class="rounded-menu settings-flyout"
  >
    <div part="container" class="settings-container">
      <ion-grid class="settings-header-grid">
        <ion-row class="settings-button-row">
          <ion-col size="12" class="settings-button-col">
            <ion-button
              data-cy="close-settings-icon"
              class="settings-close-button"
              (click)="onCloseMenuClick()"
              fill="clear"
              size="small"
            >
              <ion-icon class="close-icon" name="close-outline"></ion-icon>
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row class="settings-title-row">
          <ion-col size="12" class="settings-title-col">
            {{ 'i18n.notifications.preferences.alertSettings' | translate }}
          </ion-col>
        </ion-row>
      </ion-grid>
      <ng-container *ngIf="userNote$ | async as userNote">
        <ng-container *ngIf="userNote.message">
          <div *ngIf="userNote.dismissable" class="alerts-off-dismiss-note">
            <div>
              <ion-icon
                class="dismiss-note-icon"
                name="alert-circle-outline"
              ></ion-icon>
            </div>
            <div class="dismiss-note-message-col">
              <p class="dismiss-note-message">{{ userNote.message }}</p>
              <div class="dismiss-note-toggle">
                <ion-checkbox
                  mode="ios"
                  (ionChange)="onDismissNoteChange()"
                ></ion-checkbox
                >Don't show this message again
              </div>
            </div>
            <div class="dismiss-note-close">
              <ion-icon
                name="close-circle-outline"
                (click)="onDismissNoteClose()"
              ></ion-icon>
            </div>
          </div>
          <div *ngIf="!userNote.dismissable" class="alerts-off-note">
            {{ userNote.message }}
          </div>
        </ng-container>
      </ng-container>
      <ion-grid class="settings-grid">
        <ion-row
          *ngIf="!(viewModel.hasActiveEmailNotifications && viewModel.hasActivePushNotifications)"
        >
          <ion-col size="12" class="alerts-off-note"
            >Note: Opt in to alerts by selecting an alert category.</ion-col
          >
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <ion-grid>
              <ion-row class="settings-label-row">
                <ion-col
                  size="12"
                  class="settings-label-col active-alerts-label"
                >
                  <span class="bold"
                    >{{ 'i18n.notifications.preferences.activeAlertsShown' |
                    translate }}</span
                  >
                  {{ 'i18n.notifications.preferences.activeAlertsUnselect' |
                  translate }}
                </ion-col>
              </ion-row>
              <ion-row class="settings-row">
                <ion-col
                  class="settings-radio-label"
                  [class.disabled]="!(viewModel.hasActiveEmailNotifications && viewModel.hasActivePushNotifications)"
                  size="6"
                >
                  {{ 'i18n.notifications.preferences.allAlertsList' | translate
                  }}
                </ion-col>
                <ion-col class="settings-radio-col" size="6">
                  <span
                    class="inactive-text"
                    *ngIf="!(viewModel.hasActiveEmailNotifications && viewModel.hasActivePushNotifications)"
                  >
                    {{ 'i18n.notifications.preferences.inactive' | translate }}
                  </span>
                  <ion-checkbox
                    data-cy="opt-out-all-checkbox"
                    [disabled]="!(viewModel.hasActiveEmailNotifications && viewModel.hasActivePushNotifications)"
                    [checked]="viewModel.hasActiveEmailNotifications && viewModel.hasActivePushNotifications"
                    (ionChange)="onOptOutAllChange()"
                    mode="ios"
                  ></ion-checkbox>
                </ion-col>
              </ion-row>
              <ion-row class="settings-row">
                <ion-col
                  class="settings-radio-label"
                  [class.disabled]="!viewModel.hasActiveEmailNotifications"
                  size="6"
                >
                  {{ 'i18n.notifications.preferences.email' | translate }}
                </ion-col>
                <ion-col class="settings-radio-col" size="6">
                  <span
                    *ngIf="!viewModel.hasActiveEmailNotifications"
                    class="inactive-text"
                    >{{ 'i18n.notifications.preferences.inactive' | translate }}
                  </span>
                  <ion-checkbox
                    data-cy="opt-out-email-checkbox"
                    mode="ios"
                    [disabled]="!viewModel.hasActiveEmailNotifications"
                    [checked]="viewModel.hasActiveEmailNotifications"
                    (ionChange)="onOptOutEmailChange()"
                  ></ion-checkbox>
                </ion-col>
              </ion-row>
              <ion-row class="settings-row">
                <ion-col
                  class="settings-radio-label"
                  [class.disabled]="!viewModel.hasActivePushNotifications"
                  size="6"
                >
                  {{ 'i18n.notifications.preferences.push' | translate }}
                </ion-col>
                <ion-col class="settings-radio-col" size="6">
                  <span
                    *ngIf="!viewModel.hasActivePushNotifications"
                    class="inactive-text"
                    >{{ 'i18n.notifications.preferences.inactive' | translate }}
                  </span>
                  <ion-checkbox
                    data-cy="opt-out-push-checkbox"
                    mode="ios"
                    [disabled]="!viewModel.hasActivePushNotifications"
                    [checked]="viewModel.hasActivePushNotifications"
                    (ionChange)="onOptOutPushChange()"
                  >
                  </ion-checkbox>
                </ion-col>
              </ion-row>
            </ion-grid>
            <form
              #changeEmailForm="ngForm"
              (ngSubmit)="validateSubmit()"
              appEmailMatch
            >
              <ion-grid class="change-email-grid">
                <ion-row class="settings-label-row">
                  <ion-col
                    size="12"
                    class="settings-label-col change-email-label"
                  >
                    {{ 'i18n.notifications.preferences.changeEmail' | translate
                    }}
                  </ion-col>
                </ion-row>
                <ion-row class="settings-email-row">
                  <ion-col size="12">
                    <ion-input
                      data-cy="change-email-input"
                      class="required-field"
                      type="email"
                      required="true"
                      maxlength="80"
                      autoGrow="true"
                      helperText="Email"
                      name="notificationEmail"
                      [(ngModel)]="notificationEmail"
                      #emailInput="ngModel"
                      email
                      required
                    ></ion-input>
                    <p
                      data-cy="invalid-email-error-text"
                      class="error-text"
                      *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)"
                    >
                      <span>*</span>{{ 'i18n.profilePage.contact.emailInvalid' |
                      translate }}
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row class="settings-email-row">
                  <ion-col size="12">
                    <ion-input
                      data-cy="confirm-email-input"
                      class="required-field"
                      type="email"
                      maxlength="80"
                      autoGrow="true"
                      required="true"
                      helperText="Confirm Email"
                      name="confirmNotificationEmail"
                      [(ngModel)]="confirmNotificationEmail"
                      #confirmEmailInput="ngModel"
                      required
                      email
                    ></ion-input>
                    <p
                      data-cy="unmatched-email-error-text"
                      class="error-text"
                      *ngIf="(confirmEmailInput.touched || confirmEmailInput.dirty) && notificationEmail && confirmNotificationEmail && notificationEmail !== confirmNotificationEmail"
                    >
                      <span>*</span>{{ 'i18n.profilePage.contact.unmatchedEmail'
                      | translate }}
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row class="email-buttons-row">
                  <ion-col class="email-buttons-col" size="12">
                    <ion-button
                      data-cy="cancel-email-change-button"
                      class="usf-clear-green-button cancel-email-change-button"
                      type="button"
                      (click)="cancelEmailChange()"
                      >{{ 'i18n.common.cancel' | translate }}
                    </ion-button>
                    <ion-button
                      data-cy="save-email-change-button"
                      class="usf-clear-green-button save-email-change-button"
                      [ngClass]="{
                        'usf-clear-green-button': !(changeEmailForm.invalid || (notificationEmail !== confirmNotificationEmail && notificationEmail && confirmNotificationEmail)),
                        'usf-clear-disabled-button': changeEmailForm.invalid || (notificationEmail !== confirmNotificationEmail && notificationEmail && confirmNotificationEmail)
                      }"
                      type="submit"
                      [disabled]="changeEmailForm.invalid || (notificationEmail !== confirmNotificationEmail && notificationEmail && confirmNotificationEmail)"
                      >{{ 'i18n.common.save' | translate }}</ion-button
                    >
                  </ion-col>
                </ion-row>
              </ion-grid>
            </form>
          </ion-col>
        </ion-row>
      </ion-grid>
      <ion-grid class="settings-footer-grid">
        <ion-row>
          <ion-col size="12">
            <div class="settings-footer-button-container">
              <ion-button
                data-cy="close-settings-button"
                (click)="onCloseMenuClick()"
                class="usf-fill-green-button"
                >{{ 'i18n.common.close' | translate }}</ion-button
              >
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-menu>
</ng-container>
